const LanZH = require('../lan/zh_CN.js').default
const LanTW = require('../lan/zh_TW.js').default
const LanTR = require('../lan/tr.js').default
const LanEN = require('../lan/en').default
const LanPT = require('../lan/pt').default

let language = 'zh';
var JsSrc =(navigator.language || navigator.browserLanguage).toLowerCase();
if(JsSrc.indexOf('en')>=0){
    language = "en";
}else if(JsSrc.indexOf('tr')>=0){
   language = "tr";
}else if(JsSrc.indexOf('tw')>=0){
	language = "tw";
}else if(JsSrc.indexOf('pt')>=0){
	language = "pt";
}

if(localStorage.getItem('WIZARD_MEMBER_LANGUAGE')){
	language = localStorage.getItem('WIZARD_MEMBER_LANGUAGE');
}
if(language != 'zh' && language != 'tr' && language != 'en' && language != 'tw' && language != 'pt') language = "zh";

export default{
	currentLanguage:language,
	lans:{
		en:LanEN,
		zh:LanZH,
		tr:LanTR,
		tw:LanTW,
		pt:LanPT
	}
}